class PredictiveSearch extends SearchForm {
	constructor() {
		super();
		this.cachedResults = {};
		this.predictiveSearchResults = this.querySelector(
			"[data-predictive-search]",
		);
		this.allPredictiveSearchInstances =
			document.querySelectorAll("predictive-search");
		this.isOpen = false;
		this.abortController = new AbortController();
		this.searchTerm = "";
		this.body = document.querySelector("body");
		this.headerBottom = document.querySelector(".header__bottom");
		this.promoModal = document.querySelector(".search__modal");
		this.headerInput = document.querySelector(".search-modal .search__input");
		this.calcHeight();
		this.setupEventListeners();

		const searchResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 991) {
				this.calcHeight(65);
			} else {
				this.calcHeight(0);
			}
		});

		searchResizeObserver.observe(this.body);
	}

	calcHeight(buttonHeight) {
		if (!buttonHeight) buttonHeight = 0;

		let heightSearchTop = document.querySelector(".search__form__wrapper")
			? document.querySelector(".search__form__wrapper").getBoundingClientRect()
					.height
			: 0;
		let heightInput = this.headerInput
			? this.headerInput.getBoundingClientRect().height
			: 0;

		if (document.querySelector(".predictive-search")) {
			let clientHeight = document.documentElement.clientHeight;
			let maxHeightAllowed =
				clientHeight -
				heightSearchTop -
				heightInput -
				buttonHeight -
				10;
			document.querySelector(
				".predictive-search",
			).style.maxHeight = `${maxHeightAllowed}px`;
		}
	}

	setupEventListeners() {
		this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
		this.input.addEventListener("focus", this.onFocus.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.addEventListener("keyup", this.onKeyup.bind(this));
		this.addEventListener("keydown", this.onKeydown.bind(this));
	}

	getQuery() {
		return this.input.value.trim();
	}

	onChange() {
		const newSearchTerm = this.getQuery();
		if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
			// Remove the results when they are no longer relevant for the new search term
			// so they don't show up when the dropdown opens again
			this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
		}

		// Update the term asap, don't wait for the predictive search query to finish loading
		this.updateSearchForTerm(this.searchTerm, newSearchTerm);

		this.searchTerm = newSearchTerm;

		if (!this.searchTerm.length) {
			this.close(true);
			return;
		}

		this.getSearchResults(this.searchTerm);
	}

	onFormSubmit(event) {
		if (
			!this.getQuery().length ||
			this.querySelector('[aria-selected="true"] a') ||
			event.submitter.classList.contains("card__link")
		)
			event.preventDefault();
	}

	onFormReset(event) {
		super.onFormReset(event);
		if (super.shouldResetForm()) {
			this.searchTerm = "";
			this.abortController.abort();
			this.abortController = new AbortController();
			this.closeResults(true);
		}
	}

	onFocus() {
		const currentSearchTerm = this.getQuery();
		if (this.classList.contains("search-modal__form")) {
			if (this.headerBottom) {
				this.headerBottom.classList.add("header__bottom--visible");
			}
			if (this.promoModal) {
				this.promoModal.classList.remove("search__modal--hidden");
			}
		}

		if (!currentSearchTerm.length) {
			return;
		}

		if (this.searchTerm !== currentSearchTerm) {
			// Search term was changed from other search input, treat it as a user change
			this.onChange();
		} else if (this.getAttribute("results") === "true") {
			this.open();
			if (this.promoModal) {
				this.promoModal.classList.add("search__modal--hidden");
			}
		} else {
			this.getSearchResults(this.searchTerm);
		}
	}

	onFocusOut() {
		if (this.classList.contains("search-modal__form")) {
			if (this.headerBottom) {
				this.headerBottom.classList.remove("header__bottom--visible");
			}
		}
		if (!this.classList.contains("search-modal__form")) {
			setTimeout(() => {
				if (!this.contains(document.activeElement)) this.close();
			});
		}
	}

	onBlur() {
		if (this.headerInput) this.headerInput.blur();
	}

	onKeyup(event) {
		if (!this.getQuery().length) this.close(true);
		event.preventDefault();

		switch (event.code) {
			case "Enter":
				event.preventDefault();
				this.selectOption();
				break;
			case "Escape":
				this.closeResults(true);
				if (this.promoModal && this.classList.contains("search-modal__form")) {
					this.promoModal.classList.add("search__modal--hidden");
				}
				break;
		}

		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	onKeydown(event) {
		// Prevent the cursor from moving in the input when using the up and down arrow keys
		if (event.code === "ArrowUp" || event.code === "ArrowDown") {
			event.preventDefault();
		}
	}

	updateSearchForTerm(previousTerm, newTerm) {
		const searchForTextElement = this.querySelector(
			"[data-predictive-search-search-for-text]",
		);
		const currentButtonText = searchForTextElement?.innerText;
		if (currentButtonText) {
			if (
				currentButtonText.matchAll(new RegExp(previousTerm, "g")).length > 1
			) {
				// The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
				return;
			}
			const newButtonText = currentButtonText.replace(previousTerm, newTerm);
			searchForTextElement.innerText = newButtonText;
		}
		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	selectOption() {
		const selectedOption = this.querySelector(
			'[aria-selected="true"] a, button[aria-selected="true"]',
		);

		if (selectedOption) selectedOption.click();
	}

	// ---- 自建预搜索辅助函数 ----

	// 转义文本，防 XSS（照搬 artist 页做法）
	escapeHtml(text) {
		const div = document.createElement("div");
		div.textContent = text == null ? "" : String(text);
		return div.innerHTML;
	}

	// 价格格式化：JSON 的 price 单位是「分」（照搬 artist 页 formatMoney）
	formatMoney(cents) {
		const amount = (Number(cents) / 100).toFixed(2);
		const currency =
			window.Shopify && window.Shopify.currency && window.Shopify.currency.active
				? window.Shopify.currency.active
				: "";
		if (currency === "HKD") return "HK$" + amount;
		if (currency === "TWD") return "NT$" + amount;
		return "$" + amount;
	}

	// 用 products JSON 自己拼下拉 HTML；aliasHit 命中时顶部加艺人提示行
	buildDropdownHTML(products, aliasHit) {
		const esc = this.escapeHtml.bind(this);
		let aliasHTML = "";
		if (aliasHit && window.AliasIndex && window.AliasIndex.artistPageUrl) {
			const artistUrl =
				window.AliasIndex.artistPageUrl +
				"?name=" +
				encodeURIComponent(aliasHit);
			aliasHTML =
				'<li class="predictive-search__list-item ps-alias-hint" role="option" aria-selected="false">' +
				'<a class="ps-alias-hint__link" href="' +
				esc(artistUrl) +
				'">' +
				'<span class="ps-alias-hint__icon" aria-hidden="true">🎤</span>' +
				'<span class="ps-alias-hint__text">找到藝人：<strong class="ps-alias-hint__name">' +
				esc(aliasHit) +
				"</strong></span>" +
				"</a>" +
				"</li>";
		}

		let itemsHTML = "";
		if (products && products.length) {
			itemsHTML = products
				.map((p) => {
					const url = esc(p.url || "#");
					const title = esc(p.title || "");
					const price = this.formatMoney(p.price);
					const img = p.featured_image
						? '<img class="ps-item__img" src="' +
						  esc(p.featured_image) +
						  '" alt="' +
						  title +
						  '" loading="lazy" width="48" height="48">'
						: '<span class="ps-item__img ps-item__img--placeholder" aria-hidden="true"></span>';
					return (
						'<li class="predictive-search__list-item" role="option" aria-selected="false">' +
						'<a class="ps-item" href="' +
						url +
						'">' +
						img +
						'<span class="ps-item__info">' +
						'<span class="ps-item__title">' +
						title +
						"</span>" +
						'<span class="ps-item__price">' +
						esc(price) +
						"</span>" +
						"</span>" +
						"</a>" +
						"</li>"
					);
				})
				.join("");
		}

		if (!aliasHTML && !itemsHTML) {
			return (
				'<div class="predictive-search predictive-search--empty">' +
				'<p class="ps-empty">無相關結果</p>' +
				"</div>"
			);
		}

		return (
			'<div class="predictive-search" id="predictive-search-results-groups-wrapper">' +
			'<ul class="predictive-search__results-list active" role="listbox" tabindex="-1">' +
			aliasHTML +
			itemsHTML +
			"</ul>" +
			"</div>"
		);
	}

	getSearchResults(searchTerm) {
		const queryKey = searchTerm.replace(" ", "-").toLowerCase();
		this.setLiveRegionLoadingState();

		// 命中缓存：只缓存 products JSON，每次渲染都重算 aliasHit
		if (this.cachedResults[queryKey]) {
			this.renderProducts(this.cachedResults[queryKey], searchTerm);
			return;
		}

		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.add("search__modal--hidden");
		}

		// 请求取消 + stale 守卫：每次请求前 abort 旧请求并重建 controller
		this.abortController.abort();
		this.abortController = new AbortController();
		const requestedTerm = searchTerm;

		const term = encodeURIComponent(searchTerm);
		const fetchUrl = `${routes.search_url}?q=${term}*&type=product&view=json`;

		fetch(fetchUrl, { signal: this.abortController.signal })
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}
				return response.json();
			})
			.then((data) => {
				// stale 守卫：响应回来时若输入已变，丢弃过期响应
				if (this.getQuery() !== requestedTerm) return;

				const products = (data && data.products ? data.products : []).slice(
					0,
					6,
				);

				// 只缓存 products JSON（同步到所有实例）
				this.allPredictiveSearchInstances.forEach((instance) => {
					instance.cachedResults[queryKey] = products;
				});

				this.renderProducts(products, requestedTerm);
			})
			.catch((error) => {
				if (error?.code === 20 || error?.name === "AbortError") {
					// 请求被取消，忽略
					return;
				}
				console.warn("Predictive search: fetch error", error);
				this.close();
			});
	}

	// 渲染商品 + 别名提示（每次都重算 aliasHit，规避缓存时序坑）
	renderProducts(products, searchTerm) {
		const aliasHit =
			window.AliasIndex && typeof window.AliasIndex.findCanonical === "function"
				? window.AliasIndex.findCanonical(searchTerm)
				: null;

		const markup = this.buildDropdownHTML(products, aliasHit);
		this.renderSearchResults(markup);
		try {
			this.calcHeight();
		} catch (e) {
			console.warn("Predictive search: calcHeight error", e);
		}
		try {
			if (typeof colorSwatches === "function") colorSwatches();
		} catch (e) {
			console.warn("Predictive search: colorSwatches error", e);
		}

		// 若别名表当前未就绪，等它 ready 后用同一词重算一次（首个命中也能补出提示）
		if (
			!aliasHit &&
			window.AliasIndex &&
			typeof window.AliasIndex.ensureReady === "function" &&
			!window.AliasIndex.ready()
		) {
			window.AliasIndex.ensureReady().then(() => {
				if (this.getQuery() !== searchTerm) return;
				const hit = window.AliasIndex.findCanonical(searchTerm);
				if (!hit) return;
				const cached = this.cachedResults[searchTerm.replace(" ", "-").toLowerCase()];
				const prods = cached || products;
				this.renderSearchResults(this.buildDropdownHTML(prods, hit));
				try {
					this.calcHeight();
				} catch (e) {}
			});
		}
	}

	setLiveRegionLoadingState() {
		this.statusElement =
			this.statusElement || this.querySelector(".predictive-search-status");
		this.loadingText =
			this.loadingText || this.getAttribute("data-loading-text");

		this.setLiveRegionText(this.loadingText);
		this.setAttribute("loading", true);
	}

	setLiveRegionText(statusText) {
		if (!this.statusElement) return;
		this.statusElement.setAttribute("aria-hidden", "false");
		this.statusElement.textContent = statusText;

		setTimeout(() => {
			if (this.statusElement) {
				this.statusElement.setAttribute("aria-hidden", "true");
			}
		}, 1000);
	}

	renderSearchResults(resultsMarkup) {
		this.predictiveSearchResults.innerHTML = resultsMarkup;
		this.setAttribute("results", true);

		this.open();
		try {
			this.setLiveRegionResults();
		} catch (e) {
			console.warn("Predictive search: setLiveRegionResults error", e);
		}
		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.add("search__modal--hidden");
		}
	}

	hidePromoBlock() {
		document.querySelector(".search__recomendation")
			? document.querySelector(".search__recomendation").classList.add("hidden")
			: false;
		document.querySelector(".search__line")
			? document.querySelector(".search__line").classList.add("hide")
			: false;
	}

	showPromoBlock() {
		document.querySelector(".search__recomendation")
			? document.querySelector(".search__recomendation").classList.remove("hidden")
			: false;
		document.querySelector(".search__line")
			? document.querySelector(".search__line").classList.remove("hide")
			: false;
	}

	setLiveRegionResults() {
		this.removeAttribute("loading");
		const countEl = this.querySelector("[data-predictive-search-live-region-count-value]");
		if (countEl) {
			this.setLiveRegionText(countEl.textContent);
		}
	}

	open() {
		this.setAttribute("open", true);
		this.input.setAttribute("aria-expanded", true);
		this.isOpen = true;
		this.parentElement.parentElement.parentElement.classList.add('predictive-open');
		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.remove("search__modal--hidden");
		}
	}

	close(clearSearchTerm = false) {
		this.closeResults(clearSearchTerm);
		this.parentElement.parentElement.parentElement.classList.remove('predictive-open');
		this.isOpen = false;
	}

	closeResults(clearSearchTerm = false) {
		if (clearSearchTerm) {
			this.input.value = "";
			this.removeAttribute("results");
		}
		const selected = this.querySelector('[aria-selected="true"]');

		if (selected) selected.setAttribute("aria-selected", false);

		this.input.setAttribute("aria-activedescendant", "");
		this.removeAttribute("loading");
		this.removeAttribute("open");
		this.input.setAttribute("aria-expanded", false);
		this.predictiveSearchResults.removeAttribute("style");
		if (this.promoModal) {
			this.promoModal.classList.add("search__modal--hidden");
		}
	}
}

customElements.define("predictive-search", PredictiveSearch);
